export default "__VITE_ASSET__CbIs_QFC__"